import React from 'react';

import { EmulateAccessPoint } from '../components/EmulateAccessPoint/EmulateAccessPoint';
import { useHomeData } from '../components/LoadHomeData/HomeDataProvider';
import { NoAccessToView } from '../components/NoAccessToView/NoAccessToView';
import { useTranslations } from '../components/Translations/TranslationsProvider';

export const AccessEmulation = () => {
    const { translations } = useTranslations();
    const { homepageData } = useHomeData();
    const isGuard = homepageData?.authorizations?.mayUseGuardsMobileFx ?? false;

    return (
        <>
            {!isGuard && <NoAccessToView translations={translations} />}
            {isGuard && <EmulateAccessPoint translations={translations} />}
        </>
    );
};
